// src/context/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

// Create Context for Authentication
const AuthContext = createContext();

// Custom hook to use the AuthContext
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    // Load user data from localStorage on app startup
    useEffect(() => {
        const userData = localStorage.getItem('user');
        if (userData) {
            setUser(JSON.parse(userData)); // Parse and set the user if available
        }
    }, []);

    const login = (userData) => {
        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData)); // Store the user data in localStorage
    };

    const logout = () => {
        try {
            // Remove user and any cached onboarding flags
            const userData = localStorage.getItem('user');
            const email = userData ? (JSON.parse(userData)?.email || null) : null;

            // Remove the stored user
            localStorage.removeItem('user');

            // Remove onboarding caches (both local and session) for safety
            if (email) {
                const k = `onboarded:${email}`;
                try { localStorage.removeItem(k); } catch {}
                try { sessionStorage.removeItem(k); } catch {}
            }

            // Also sweep any generic onboarded:* keys to be safe
            try {
                const toRemove = [];
                for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i);
                    if (key && key.startsWith('onboarded:')) toRemove.push(key);
                }
                toRemove.forEach((k) => localStorage.removeItem(k));
            } catch {}

            try {
                const toRemove = [];
                for (let i = 0; i < sessionStorage.length; i++) {
                    const key = sessionStorage.key(i);
                    if (key && key.startsWith('onboarded:')) toRemove.push(key);
                }
                toRemove.forEach((k) => sessionStorage.removeItem(k));
            } catch {}
        } finally {
            setUser(null);
        }
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
